import { Injectable } from '@angular/core';
import { StorageKeys } from "../../util/constants";

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor() { }

  // Set a key-value pair in localStorage
  setItem<T>(key: StorageKeys, value: T): void {
    localStorage.setItem(key, this.serialize(value));
  }

  // Get the value associated with the key from localStorage
  getItem<T>(key: StorageKeys): T | null {
    const storedItem = localStorage.getItem(key);
    if (storedItem) {
      return this.deserialize<T>(storedItem);
    }
    return null;
  }

  // Remove the key-value pair from localStorage
  removeItem(key: string): void {
    localStorage.removeItem(key);
  }

  // Clear all items from localStorage
  clear(): void {
    localStorage.clear();
  }

  // Serialize data to JSON
  private serialize<T>(data: T): string {
    return JSON.stringify(data);
  }

  // Deserialize data from JSON
  private deserialize<T>(data: string): T {
    return JSON.parse(data) as T;
  }
}
